import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPencil2"><Path d="M18.4258 11.4866L9.48633 20.427L2.25781 21.7414L3.57227 14.5129L12.5117 5.57249L18.4258 11.4866Z" fill="currentColor"/><Path d="M14.543 3.54222C16.1761 1.90943 18.8239 1.90943 20.457 3.54222C22.0901 5.17529 22.0899 7.82309 20.457 9.45628L19.4863 10.426L13.5723 4.51194L14.543 3.54222Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil2;
